import React, { useEffect } from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import useAuth from '../../context/auth/useAuth'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { getUser } from '../../actions/usersActions'
import Version from '../../version'

export default function Dashboard() {
    const { t } = useTranslation()
    const dispatch = useDispatch()
	const {client} = useAuth()

    const {user} = useSelector(state=>state.users)

    useEffect(() => {
        window.scrollTo({
            top:0,
            behavior: 'instant'
        })
        if(client){
            dispatch(getUser(client?.id))
        }
    },[dispatch, t, client])

    return (
        <Container className='p-5'> 
            <Row>
                <Col>
                    <div className='sd-label-dashboard'>{t('client.dashboard.welcome')}</div>
                    <div className="sd-label-userdashboard colornaranja">{user?.firstname}</div>
                </Col>
            </Row>
            <Row className='mb-5'>
                <Col>
                    <h3>{t('client.dashboard.subwelcome')}</h3>
                </Col>
            </Row>
            <Row>
                <Col>
                    <Link to="/client/takerestaurant" className='btn btn-dashboard btn-dashboard-orange'>
                        {t('client.dashboard.takeorder')}
                    </Link>
                    <Link to="/client/pendingorders" className='btn btn-dashboard btn-dashboard-white'>
                        {t('client.dashboard.pendingorder')}
                    </Link>
                    <Link to="/client/completedorders" className='btn btn-dashboard btn-dashboard-white'>
                        {t('client.dashboard.completedorder')}
                    </Link>
                </Col>
            </Row>
            <Row>
                <Col className='text-center mt-2'>
                    <Version />
                </Col>
            </Row>
        </Container>
    )
}